export const CommissionCreateTargetStatus = {
  Created: 'created',
  Approved: 'approved',
} as const;

export type CommissionCreateTargetStatus =
  (typeof CommissionCreateTargetStatus)[keyof typeof CommissionCreateTargetStatus];
